<template>
  <div>
        <div class="join-steps" v-show="mode != ''">
          <div class="mini-title-blue">
              {{content["f2g.simorder.step2"]}}
          </div>
          <div class="title-overlay4">
              {{content["f2g.simorder.step2title"]}}
          </div>
          <div class="all-boxes-card-amount">
              <div class="box-card-amount" v-for="product in simInfo" :key="product" @click="selectProduct($event)" :id="product.productId">
                <div
                  v-if="product.isESIM !== null"
                  class="sim-ribbon"
                  :class="{ esim: product.isESIM, physical: !product.isESIM }"
                >
                  <span class="sim-text">
                    {{ 
                      product.isESIM 
                        ? 'eSIM' 
                        : 'Φυσική SIM' 
                    }}
                  </span>
                </div>

                <div class="bold-text1-balance">
                    {{product.totalPrice}}€
                </div>
                <div class="bold-text2-balance">
                    {{product.displayName}}
                </div>
                <div class="esim-info" v-if="product.isESIM" v-html="content['f2g.simorder.eSIMinfo']"></div>
              </div>
          </div>
        </div>

       
        <div id="captcha-box" v-show="captchaVersion=='v2'">
        <div id="captchaTest"></div>
        <div class="row">
            <div class="col-md-6 col-xs-12">
                <p class="error"><span class="field-validation-error"></span></p>
            </div>
        </div>
        </div>
        <span class="element-not-match">{{errorMessage}}</span>

        <div class="remarks-bundles-details">
              <a class="main-title-bundles" href="/gr/f2g/f2g-sim-paraggelia/parathrhseis/" target="_blank">{{content["f2g.simorder.remarks"]}}</a>
          </div>



    <!-- Sticky Footer ******************************************************************************************************-->
        <div class="footer-amount-template" v-if="productSelected">
            <div class="f2g-wind-container footer-amount-bundles-details">
                <div class="white-footer">
                    <div class="text-amount">{{content["f2g.simorder.price"]}}</div>
                    <div class="amount-bundles-details">{{selectedSim.totalPrice}}€</div>
                </div>
                <div class="blue-footer">
                    <a style="cursor:pointer" @click="submitPrepaidOrder(selectedSim.productId);" class="hidden-lg hidden-md"> 
                        <div class="container-button blue-btn">
                        {{content["f2g.simorder.order"]}}
                        </div>
                    </a>
                    <div class="hidden-sm hidden-xs" style="cursor:pointer" @click="submitPrepaidOrder(selectedSim.productId);">{{content["f2g.simorder.order"]}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'NewNumber',
  props: {
    content: Object,
    simInfo: Array
  },
  data: function() {
      return {
           productSelected: false,
           selectedSim: {},
           captchaVersion: "v3",
           widgetId: "",
           orderComplete: false,
           errorMessage: "",
           modalInitialized: false,
      }
  },
  mounted () {
      if (!$(".all-boxes-card-amount").hasClass("slick-slider")){

        $('.all-boxes-card-amount').slick({
            infinite: false,
            variableWidth: true,
            arrows: false,
            slidesToShow: 4,
            responsive: [
                  {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  }
                  },
                  {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  }
                  },
                  {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                  }
                  },
                  {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                  }
                  }
              ]
          });
      }
      if ($(".open-as-modal") !== null && this.modalInitialized === false) {
        //initialize terms modal
        $(".open-as-modal").each(function (index, value) {
          $(this).animatedModal({
            animatedIn: 'bounceIn',
            animatedOut: 'bounceOut',
            animationDuration: '.6s',
            color: '#FFFFFF',
            // Callbacks
            beforeOpen: function () {
            },
            afterOpen: function () {
            },
            beforeClose: function () {
            },
            afterClose: function () {
            }
          });
        });
        this.modalInitialized = true;
      }
      this.setEqualHeights();
      var x = document.getElementsByClassName("box-card-amount")[0];
      x.classList.add("active-blue-line");
      var simID = document.getElementsByClassName("box-card-amount")[0].id;
      var self = this;
      this.simInfo.forEach(function (product) {
        if (product.productId == simID) self.selectedSim = product;
      });
      this.productSelected = true;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setEqualHeights);
  },
  methods: {
    selectProduct(event) {
         var products = document.querySelectorAll(".box-card-amount");

         [].forEach.call(products, function(el) {
            el.classList.remove("active-blue-line");
         });

         var simID;
         if (event.target.className == ".box-card-amount") {
            event.target.classList.add("active-blue-line");
            simID = event.target.id;
         } else {
            event.target.closest(".box-card-amount").classList.add("active-blue-line");
            simID = event.target.closest(".box-card-amount").id;
         }

         var self = this;
         this.simInfo.forEach(function (product) {
            if (product.productId == simID) self.selectedSim = product;
         });
         this.productSelected = true;
      },
      submitPrepaidOrder(productId) {
        var locale = document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";

        var submitOrder = `${document.getElementsByTagName("body")[0].dataset.windsite}deep-linking?journeyType=tangibleOnly&tangibleId=${productId}`;
        window.location.replace(submitOrder);
            
      },
      setEqualHeights() {
        this.$nextTick(() => {
          const elements = this.$el.querySelectorAll('.box-card-amount');
          let maxHeight = 0;

          elements.forEach(el => {
            el.style.height = 'auto';
          });

          elements.forEach(el => {
            if (el.offsetHeight > maxHeight) {
              maxHeight = el.offsetHeight;
            }
          });

          elements.forEach(el => {
            el.style.height = maxHeight + 'px';
          });
        });
      }
   },
   validateTerms(){
      var locale = document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";
      var termsSelected = true;
      if (document.getElementById("ritemb").checked == false){
         document.getElementById("termsError").innerHTML = (locale == "en_US") ? "Please accept the terms of use." : "Η αποδοχή των όρων της προσφοράς είναι υποχρεωτική.";
         termsSelected = false;
      } else {
         document.getElementById("termsError").innerHTML = "";
      }

      return termsSelected;
   },
   validateSelectsAndTerms(){
      var terms = this.validateTerms();
      return terms;
   },
   validateCaptcha() {
      if (this.captchaVersion == "v2" && grecaptcha.getResponse(this.widgetId).length == 0) {
        $('body').data('locale') == "el_GR" ? 
          $('#captcha-box > div > div > p > span').html('To captcha πρέπει να συμπληρωθεί.') :
          $('#captcha-box > div > div > p > span').html('Please fill in the captcha.');
        $("#captcha-box > div > div > p > span").show();
      } else {
        $('#captcha-box > div > div > p > span').html('') 
        $("#captcha-box > div > div > p > span").hide();
      }
      return this.captchaVersion == "v3" || grecaptcha.getResponse(this.widgetId).length != 0;
   },
   prepareRequest(){
      //prepare request
      var request = {};
      request.caller = {};

      //Set caller
      //Replace values
      request.caller.callingSystem = "WINDweb";
      request.caller.salesCode = "";
      request.caller.username = "username";
      request.caller.locale = document.getElementsByTagName("body")[0].dataset.locale ? document.getElementsByTagName("body")[0].dataset.locale : "el_GR";
      request.caller.channel = "F2G";
      request.caller.data = "";

      request.orderType = "f2gsimorder"

      request.products = [];
      var product = {};
      product.productId = this.selectedSim.productId;
      product.productName = this.selectedSim.description;
      product.productType = this.selectedSim.type;
      request.products.push(product);
       
      return request;
  }
}
</script>

<style>

.sim-ribbon {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 70px 70px 0 0;
  border-top-left-radius: 6px;
  top: 0;
  left: 0;
  z-index: 2;
}

.sim-ribbon.esim {
  border-color: #00bcd4 transparent transparent transparent;
}

.sim-ribbon.physical {
  border-color: #9e9e9e transparent transparent transparent;
}

.sim-text {
  position: absolute;
  left: 0;
  width: 45px;
  font-weight: bold;
  color: white;
  text-align: center;
  transform: rotate(-45deg);
  pointer-events: none;
}

.sim-ribbon.esim .sim-text {
  bottom: 37px;
  font-size: 14px;
}

.sim-ribbon.physical .sim-text {
  bottom: 32px;
  font-size: 11px;
}

.esim-info {
  font-family: Manrope-Normal;
  font-size: 12px;
}

</style>